import React from 'react';
import {ProgressBar} from "react-step-progress-bar";
import LoadingSpinner from "../../../components/LoadingSpinner";
import User from "../../../models/User";
import {Link} from "react-router-dom";
import {useAuth} from "../../../providers/AuthProvider";

const JobProfileSummary = props => {

    const {auth} = useAuth();
    if (!auth) return null;

    const progress = auth.profileProgress();

    return (
        <>
            <div className={TB.mapClass("job-profile-summary-container flex flex-row m-0", {disabled:props.disabled})}>

                {props.disabled && (
                    <div className="match-updating">
                        <LoadingSpinner size={'lg'}/>
                    </div>
                )}
                <div className="job-profile-summary col col-auto">
                    <div className="profile-progress-header">
                        <h4>
                            Complete your Profile
                        </h4>
                        <div className="profile-progress">
                            <p className="progress-title">
                                {`${progress}% of setup complete`}
                            </p>
                            <ProgressBar
                                filledBackground={TB.config('color.light_green')}
                                height={20}
                                percent={progress}
                                unfilledBackground={TB.config('color.backgroundGray')}/>
                        </div>
                    </div>

                    <div className="profile-sections-progress">
                        {auth.getFullProfileStepsForTalent().map(Section => {
                            const completed = Section.hasCompleted(auth);
                            const lastUpdated = auth[Section.LastUpdatedMethod]?.();

                            return (
                                <div className="section-progress-item" key={Section.path}>
                                    <i className={TB.mapClass('fas', {
                                        'text-danger fa-times-circle': !completed,
                                        'text-success fa-check-circle': completed
                                    })}/>

                                    <div className="pl-3 flex flex-col sm:flex-row">
                                        <div className="section-completion">
                                            <Link className="section-link" onClick={() => {
                                                if (props.onRequestClose) {
                                                    props.onRequestClose()
                                                }
                                            }} to={`/talent/application${Section.path}`}>
                                                {Section.StepTitle}
                                            </Link>
                                        </div>

                                        <div className="section-summary">
                                            <p>{Section.ProfileSectionSummary(auth)}</p>
                                        </div>
                                    </div>

                                    <div className="section-updates">
                                        {completed && TB.isInteger(lastUpdated) && (
                                            <div className="header-last-updated">
                                                <p className={lastUpdated > 30 ? 'text-danger' : ''}>
                                                    <i className="fas fa-clock"/>
                                                    &nbsp; {`${lastUpdated} day${(lastUpdated === 1) ? '' : 's'} ago`}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )

                            // return (
                            //     <div className="section-progress-item" key={Section.path}>
                            //         <div className="section-completion">
                            //             <i className={TB.mapClass('fas', {
                            //                 'text-danger fa-times-circle': !completed,
                            //                 'text-success fa-check-circle': completed
                            //             })}/>

                            //             <Link className="section-link" onClick={() => {
                            //                 if (props.onRequestClose) {
                            //                     props.onRequestClose()
                            //                 }
                            //             }} to={`${TalentApplication.path}${Section.path}`}>
                            //                 {Section.StepTitle}
                            //             </Link>

                            //         </div>

                            //         <div className="section-summary">

                            //             <p>{Section.ProfileSectionSummary(auth)}</p>
                            //         </div>

                            //         <div className="section-updates">

                            //             {completed && TB.isInteger(lastUpdated) && (
                            //                 <div className="header-last-updated">
                            //                     <p className={lastUpdated > 30 ? 'text-danger' : ''}>
                            //                         <i className="fas fa-clock"/>
                            //                         &nbsp; {`${lastUpdated} day${(lastUpdated === 1) ? '' : 's'} ago`}
                            //                     </p>
                            //                 </div>
                            //             )}

                            //         </div>
                            //     </div>
                            // )
                        })}
                    </div>
                </div>
                    <div className="match-score-img hidden flex-col lg:flex lg:w-2/5">
                        <p className="px-4">You will better your chances of winning the job by having a complete and up to date profile.</p>

                        {TB.platformHasImage('Asset_Talent_Matching_Job_Graphic') && (
                            <img src={laravel.platform_settings.Asset_Talent_Matching_Job_Graphic} className="img-fluid"/>
                        )}
                    </div>
            </div>

            <div className="match-score-img py-5 lg:hidden">
                <p className="px-4 m-0 text-center">You will better your chances of winning the job by having a complete and up to date profile.</p>
            </div>
        </>
    )

};


export default JobProfileSummary;